<script>
  import Favorite from "./Favorite.svelte";
  import PurchaseButton from "./PurchaseButton.svelte";
  import SubscriptionButton from "./SubscriptionButton.svelte";
  import { afterUpdate } from "svelte";
  import {
    formatDate,
    formatPrice,
    formatTitle,
  } from "../services/utilities.js";

  export let product = null;
  export let subDetails = {};
  export let userRentedPrev = null;
  let pieceCount = null;

  afterUpdate(async () => {
    if (product.piece_count) pieceCount = product.piece_count;
    else pieceCount = null;
  });

  function getImgURL(product) {
    if (product.images && product.images.length > 0) {
      return `${product.images[0].url}${product.images[0].filename}-sm.${product.images[0].extension}`;
    }
    return null;
  }
</script>

<div class="product">
  <div class="product-header">
    <div class="product-header-info">
      <a
        class="product-link"
        href={`/product/${formatTitle(product.title)}/sku/${product.sku}`}
      >
        <h2 class="product-title" title={product.title}>{product.title}</h2>
        {#if pieceCount}
          <p class="product-piece-count">{pieceCount} Pieces</p>
        {/if}

        {#if product.price}
          <p class="product-price">
            {#if product.sale_price}
              <s>{formatPrice(product.price)}</s>
              {formatPrice(product.sale_price)}
            {:else}{formatPrice(product.price)}{/if}
          </p>
        {/if}
        {#if product.product_type.id === 1}
          <div class="rented-prev">
            {#if userRentedPrev}
              <span>
                Rented on {formatDate(userRentedPrev, {
                  formatStr: "MMMM dd, yyyy",
                  showTime: false,
                })}
              </span>
              <svg class="icon">
                <use href="/icons.svg#check" />
              </svg>
            {/if}
          </div>
        {/if}
      </a>
    </div>
    <div>
      <Favorite {product} />
    </div>
  </div>

  <a
    class="product-link"
    href={`/product/${formatTitle(product.title)}/sku/${product.sku}`}
  >
    <div class="product-image">
      <img
        src={getImgURL(product)}
        alt={`${product.title}${pieceCount ? ` ${pieceCount} piece` : ""} jigsaw puzzle`}
        loading="lazy"
      />
    </div>
  </a>

  <div class="product-actions">
    {#if !subDetails.valid || product.product_type.id > 1}
      <!-- Hide Quick Add To Cart button for Rentals unless you are a subscription member -->
      <PurchaseButton {product} compact={true} />
    {:else if subDetails.valid}
      <SubscriptionButton
        {product}
        subscriptionDetails={subDetails}
        compact={true}
      />
    {/if}
  </div>
</div>

<style type="text/less">
  .rented-prev {
    height: 18px;
    span {
      font-size: 10px;
    }
  }
  .product {
    border-radius: var(--border-radius);
    background: var(--col-gray-98);
    border: solid 1px var(--col-gray-90);
    height: 100%;
  }

  .product-link {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: var(--spacing-sm);
    text-decoration: none;
    color: var(--col-text);

    &:hover {
      background: var(--col-gray-100);
    }
  }

  .product-image {
    height: 12rem;

    img {
      display: block;
      margin: auto;
      width: 100%;
      height: 100%;
      object-fit: cover;
      background: var(--col-gray-80);
      color: var(--col-gray-100);
      text-align: center;
      line-height: 12em;
    }
  }

  .product-title {
    font-size: 1rem;
    font-weight: 400;
    line-height: var(--line-height);
    text-decoration: none;
    margin-top: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .product-price {
    margin: calc(-1 * var(--spacing-sm)) 0 var(--spacing-sm);
    font-weight: 700;
  }

  .product-piece-count {
    margin: calc(-1 * var(--spacing-sm)) 0 var(--spacing-sm);
  }

  .product-actions {
    display: flex;
    border-top: solid 1px var(--col-gray-90);
    justify-content: space-around;
    flex-wrap: wrap;
    padding: var(--spacing-sm);

    > .btn {
      flex: 0 1 auto;
    }
  }

  .product-out-of-stock {
    align-self: center;
    margin-right: var(--spacing-xs);
  }

  .product-header {
    display: flex;
    justify-content: space-between;
  }

  .product-header-info {
    max-width: 70%;
    flex: 4;
  }

  .icon {
    color: var(--col-accent-1);
    font-size: 1.25em;
    margin: 0 auto;
  }
</style>
